import { render, staticRenderFns } from "./faculty.vue?vue&type=template&id=31399f12&scoped=true"
import script from "./faculty.vue?vue&type=script&lang=js"
export * from "./faculty.vue?vue&type=script&lang=js"
import style0 from "./faculty.vue?vue&type=style&index=0&id=31399f12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31399f12",
  null
  
)

export default component.exports